export const apiConfig = {
	baseUrl: import.meta.env.VITE_API_GATEWAY_ENDPOINT || `/`,
	websocketBaseUrl: import.meta.env.VITE_WEBSOCKET_ENDPOINT,
	domain: import.meta.env.VITE_AUTH0_DOMAIN,
	audience: import.meta.env.VITE_AUTH0_AUDIENCE,
	issuer: import.meta.env.VITE_OIDC_ISSUER,
	clientId: import.meta.env.VITE_PRICING_WEBAPP_OIDC_CLIENT_ID,
	scope: 'read:current_user update:current_user_metadata openid profile email',
}
